import React from 'react'
import Helmet from 'react-helmet'
import {
  initialiseSegment,
  OneTrustConsent,
  GTMContainer,
} from '@crunchyroll/cr-static-shared-components'

import favicon from '@images/favicon.png'
import { useSiteMetadata } from '@hooks/use-site-metadata'

const wrapPage = ({
  element,
  props: {
    location: { pathname },
  },
}) => {
  const PageComponent = () => {
    const {
      siteMetadata: { baseUrl: url },
    } = useSiteMetadata()

    const canonicalHref = `${url}${pathname}`

    return (
      <>
        <OneTrustConsent />

        {typeof window !== 'undefined' && initialiseSegment(false)}

        <Helmet>
          <link rel="icon" href={favicon} />
          <link rel="canonical" href={canonicalHref} />
          <meta property="og:url" content={canonicalHref} />
        </Helmet>
        <GTMContainer />
        {element}
      </>
    )
  }

  return <PageComponent />
}

export default wrapPage
